import { useState } from 'react';

import { loadFromLocalStorage, saveInLocalStorage } from '../../common/onboarding/handleLocalStorage';
import { type BookingOverviewColumn, defaultBookingOverviewColumns } from './bookingOverviewColumns';

const storageKey = 'bookings.overview.visibleColumns';

function loadVisibleColumns(): BookingOverviewColumn[] {
    const storedColumns: unknown = loadFromLocalStorage(storageKey);
    if (!Array.isArray(storedColumns) || !storedColumns.every(column => typeof column === 'string')) {
        return defaultBookingOverviewColumns;
    }

    return defaultBookingOverviewColumns.filter(column => column === 'resourceName' || storedColumns.includes(column));
}

export function useBookingOverviewColumns() {
    const [visibleColumns, setVisibleColumns] = useState(loadVisibleColumns);

    const changeVisibleColumns = (columns: BookingOverviewColumn[]) => {
        setVisibleColumns(columns);
        saveInLocalStorage(storageKey, columns);
    };

    return [visibleColumns, changeVisibleColumns] as const;
}
